import { render } from "./AssociationOverview.vue?vue&type=template&id=1adaba8a&scoped=true"
import script from "./AssociationOverview.vue?vue&type=script&lang=js"
export * from "./AssociationOverview.vue?vue&type=script&lang=js"

import "./AssociationOverview.vue?vue&type=style&index=0&id=1adaba8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adaba8a"]])

export default __exports__